import React from 'react';
import Toast from './Toast';
import './Toast.scss';

const ToastContainer = ({ toasts, position = 'bottom-right', onRemove }) => {
    if (!toasts || toasts.length === 0) return null;

    return (
        <div className={`toast-container toast-container--${position}`}>
            {toasts.map((toast) => (
                <Toast
                    key={toast.id}
                    {...toast}
                    position={position}
                    onClose={onRemove}
                />
            ))}
        </div>
    );
};

export default ToastContainer;